<ca-card ui-3 class="mt-4 md-5" *ngIf="propuesta && domicilioTomadorConfig && tomadorConfig">
    <div ca-card-title>{{'AUTOS.SIMULAR.TITULO' | translate}}</div>
    <div ca-card-content>
        <form class="form" [formGroup]="guardarForm">
            <ca-card ui-3 class="md-5" >
                <div ca-card-title>{{'GUARDAR_PROYECTO.DATOS_PROYECTO.TITULO' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="datosProyecto">
                        <app-datos-proyecto [form]="guardarForm.get('datosProyecto')"></app-datos-proyecto>
                    </div>
                </div>
            </ca-card>
            <ca-card ui-3 class="mt-3">
                <div ca-card-title>{{'COMUN.DATOS_GENERALES.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.TOMADOR' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="datosPersonalesTomador">
                        <app-datos-personales 
                            [config]="tomadorConfig"
                            [form]="guardarForm.get('datosPersonalesTomador')"
                            (personaChange)="onTomadorChange($event)"></app-datos-personales>
                    </div>
                </div>
            </ca-card>
            <ca-card ui-3 class="mt-3">
                <div ca-card-title>{{'COMUN.DATOS_DOMICILIO.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.TOMADOR' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="datosDomicilioTomador">
                        <app-datos-domicilio 
                            [config]="domicilioTomadorConfig"
                            [form]="guardarForm.get('datosDomicilioTomador')"
                            (domicilioChange)="onDomicilioTomadorChange($event)"></app-datos-domicilio>
                    </div>
                </div>
            </ca-card>
            <ca-card ui-3 class="mt-3" *ngIf="idiomas?.length > 0">
                <div ca-card-title>{{'COMUN.DATOS_IDIOMA.TITULO' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="datosIdiomas">
                        <app-idiomas 
                            [idiomas]="idiomas"
                            [form]="guardarForm.get('datosIdiomas')"></app-idiomas>
                    </div>
                </div>
            </ca-card>
            <div class="mt-3 col-12">
                <ca-label>{{'SALUD.GUARDAR.IMPRESION_COLECTIVAS' | translate}}</ca-label>
                <app-impresion-colectivas 
                    [agrupacionesPropuestas]="agrupacionesPropuestas"></app-impresion-colectivas>
            </div>
            <div class="mt-3 col-12">
                <ca-label>{{'COMUN.DATOS_CONTACTO.ENVIO_EMAIL' | translate}}</ca-label>
                <ca-radio-group  
                    id="radio_envio_email" 
                    name="radio_envio_email" 
                    [value]="mostrarEnvioEmail ? '1' : '2'"
                    (change)="cambioEnvioEmail($event)">
                    <ca-radio-button value="1" >{{'MAIN.RESPUESTA_SI' | translate}}</ca-radio-button>
                    <ca-radio-button value="2" >{{'MAIN.RESPUESTA_NO' | translate}}</ca-radio-button>
                </ca-radio-group>  
            </div>
            <div formGroupName="envioEmail" *ngIf="mostrarEnvioEmail">
                <app-envio-email [form]="guardarForm.get('envioEmail')"></app-envio-email>
            </div>
            <div class="mt-4 pb-4">
                <div class="float-left">
                    <button ca-button-secondary type="button" (click)="volver()" [disabled]="propuestaGuardada">            
                        <ca-icon>chevron_left</ca-icon>
                        {{'MAIN.BOTON_VOLVER' | translate}}
                    </button>
                </div> 
                <div class="float-right">
                    <button ca-button class="ca-btn-icon__container ml-2" type="button" id="imprimirGuardar"
                        [disabled]="guardarForm.invalid || propuestaGuardada?.codigoPropuesta"
                        (click)="guardarProyecto(true)">
                        <ca-icon>print</ca-icon>
                        {{'MENU.PRIVADO.IMPRIMIR_GUARDAR' | translate}}                     
                    </button>
                    <button ca-button class="ca-btn-icon__container ml-2" type="button" id="guardar"
                        [disabled]="guardarForm.invalid || propuestaGuardada?.codigoPropuesta"
                        (click)="guardarProyecto(false)">
                        <ca-icon>save</ca-icon>
                        {{'MENU.PRIVADO.GUARDAR' | translate}}                        
                    </button>
                </div>  
            </div>
        </form>
    </div>
</ca-card>